import { create } from 'zustand'

export const useAllReportsStore = create(set => ({
  options: [
    { id: '', text: 'All' },
    { id: 'artist', text: 'Artist' },
    { id: 'album', text: 'Album' },
    { id: 'song', text: 'Song' },
    { id: 'feels', text: 'Feels' },
  ],
  selectedOption: {
    id: '',
    text: 'All',
  },
  statuses: [
    { id: '', text: 'All' },
    { id: 'new', text: 'New'},
    { id: 'in_progress', text: 'In Progress' },
    { id: 'resolved', text: 'Resolved' },
    { id: 'no_action', text: 'No Action' },
  ],
  selectedStatus: {
    id: '',
    text: 'All',
  },
  isResolved: false,

  setSelectedOption: newOption => set({ selectedOption: newOption }),
  setSelectedStatus: newOption => set({ selectedStatus: newOption }),
  setIsResolved: newOption => set({ isResolved: newOption }),
}))
